/* This file is autogenerated, see readme.md for instructions */
import EyeSvgIcon from '@bloomreach/banana-theme/icons/eye.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EyeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EyeSvgIcon />
    </Icon>
  );
});

EyeIcon.displayName = 'EyeIcon';

export default EyeIcon;
